import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const AutomationsPage = lazy(() => import('./pages/AutomationsPage'));

export const AutomationsRoutes: RouteObject = {
  path: 'automations',
  children: [
    { path: '', element: <AutomationsPage />, handle: { crumb: 'Automations' } },
  ],
};
